/**
 * 고도화 기능 플래그 (실행계획 8.4). 화면에는 자리를 두고 MVP 에서는 숨긴다.
 * - socialLogin: Apple·Google 로그인 (E1), WeChat (E4)
 * - translation: 채팅 원문/번역 토글 (E1)
 * - pgPayment: PG 결제수단 (E1, MVP 는 MANUAL 입금 안내)
 * - realtime: STOMP 실시간 (P3 에서 켬)
 */
const flag = (value: string | undefined) => value === 'true';

export const features = {
  socialLogin: flag(import.meta.env.VITE_FEATURE_SOCIAL_LOGIN),
  translation: flag(import.meta.env.VITE_FEATURE_TRANSLATION),
  pgPayment: flag(import.meta.env.VITE_FEATURE_PG_PAYMENT),
  realtime: flag(import.meta.env.VITE_FEATURE_REALTIME),
} as const;

export type FeatureName = keyof typeof features;
